import React, {Component} from 'react';
import Styles from './style.css';
import {Link} from 'react-router-dom';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";

import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister";
import {imagesRegister} from "../../services/imagesRegister";
import HeaderMobileMenu from "../header-mobile-menu/component";
import ModalLang from "../modal-lang/component";
import ModalLeave from "../modal-leave/component";
import {marketRegister} from "../../services/marketRegister";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import queryString from "query-string";

class HeaderSignUpOne extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: "",
            user: {},
            lang: null,
            temp_lang: null,
            language: false,
            dropdown: false,
            signup: false,
            leave: false,
            home: false,
            profile: false,
            languages: [],
            logout: false
        };
        this._lang = this._lang.bind(this);
        this._leave = this._leave.bind(this);
    };

    componentWillMount() {
        this._updateQuotesView();
        this._updateUser();
        this._updateView();
        this._updateLang();
        this._updateLanguages();
    }

    _updateQuotesView(){
        try {
            if(window.location.pathname.indexOf("quotes-custom") !== -1){
                this.setState({quotesView: "custom"});
            }
        }catch (e) {}
    }

    _updateLang(){
        this.setState({lang: langRegister.lang()});
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user
            }, () => {
                console.log(this.state.user);
            });
        }
    }

    _updateView() {
        if (this.props.view) {
            this.setState({
                view: this.props.view
            });
        } else {
            this.setState({
                view: "register"
            });
        }
    }

    _updateLanguages() {
        let languages = JSON.parse(salesChannelRegister.get("languages"))?JSON.parse(salesChannelRegister.get("languages")):[];
        this.setState({languages: languages});
    }

    _signout() {
        if(this.state.user){
            if(this.state.user.admin){
                this.setState({home: true, leave: true, logout: true});
            }else{
                demoRegister.remove();
                userRegister.remove();
                tokenRegister.remove();
                window.location.reload();
            }
        }else{
            demoRegister.remove();
            userRegister.remove();
            tokenRegister.remove();
            window.location.reload();
        }
    }

    _openMenu () {
        this.child._openMenu();
    }

    _home() {
        try {
            if(this.state.view !== "select-market"){
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/");
            }
        } catch (e) {}
    }

    _register() {
        /*
        let query = queryString.parse(this.props.props.location.search);
        if(query.from_path){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register?from_path=" + query.from_path);
        }else if(query.from){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register?from_path=" + query.from);
        }else{
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register" + "?from_path=" + this.props.props.location.pathname);
        }
        */

        if(this.props.props.location.pathname.indexOf("signup") !== -1){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register" + "?from_path=" + this.props.props.location.pathname);
        }else{
            let query = queryString.parse(this.props.props.location.search);
            if(query){
                if(query.from_path){
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register?from_path=" + query.from_path);
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register");
                }
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register");
            }
        }
    }

    _login() {
        /*
        let query = queryString.parse(this.props.props.location.search);
        if(query.from_path){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login?from_path=" + query.from_path);
        }else if(query.from){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login?from_path=" + query.from);
        }else{
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login" + "?from_path=" + this.props.props.location.pathname);
        }
        */
        if(this.props.props.location.pathname.indexOf("signup") !== -1){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login" + "?from_path=" + this.props.props.location.pathname);
        }else{
            let query = queryString.parse(this.props.props.location.search);
            if(query){
                if(query.from_path){
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login?from_path=" + query.from_path);
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
                }
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
            }
        }
    }

    _profile(){
        try {
            this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
        } catch (e) {}
    }

    _lang(lang){
        if(lang){
            langRegister.set(lang);
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            if(this.props.props.location.pathname.indexOf("image") !== -1){
                this.props.props.history.replace("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/image");
                window.location.reload();
            }else{
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/image");
            }
        }else{
            this.setState({language: false});
        }
    }

    _setLang(prop){
        if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
            this.setState({language: true, temp_lang: prop, dropdown: false}, () => {});
        }else{
            let string = "/" + marketRegister.code() + "/" + langRegister.lang();
            let re = new RegExp(string,"g");
            let url = this.props.props.location.pathname.replace(re,'');
            langRegister.set(prop);
            this.props.props.history.replace("/" + marketRegister.code() + "/" + langRegister.lang() + url);
            window.location.reload();
        }
    }

    _leave(value){
        if(value){
            if(this.state.home){
                try {
                    if(this.state.user.admin){
                        if(this.state.logout){
                            tokenRegister.remove();
                            userRegister.remove();
                            demoRegister.remove();
                        }
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                    }
                }catch (error){}
                try {
                    this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
                } catch (e) {}
            }else if(this.state.profile){
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
            }else{
                if(this.props.props.location.pathname.indexOf("image") !== -1){
                    window.location.reload();
                }else{
                    this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
                }
            }
        }else{
            this.setState({leave: false});
        }
    }

    _setView(){
        if(this.state.quotesView === "custom"){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/signup/quotes");
        }else{
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/signup/quotes-custom");
        }
    }

    _renderView(){
        try {
            return window.location.pathname.indexOf("/quotes") !== -1;
        }catch (e) {}
    }

    _renderText(item) {
        return langRegister.get("signup-header-one", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.language &&
                    <ModalLang setLang={this._lang} lang={this.state.temp_lang} props={this.props}/>
                }
                {
                    this.state.leave &&
                    <ModalLeave setLeave={this._leave} props={this.props}/>
                }
                <div className={Styles.header}>
                    {
                        this.state.dropdown &&
                        <div onClick={() => this.setState({dropdown: false})} className={Styles.languageButtonContainerOverlay}/>
                    }
                    <div className={Styles.logoContainer}>
                        <img onClick={() => {
                            if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
                                this.setState({leave: true, home: true})
                            }else{
                                this._home();
                            }}
                        } className={Styles.logoContainerIcon}
                             src={require("../../assets/images/logo.svg")}/>
                        <img onClick={() => {
                            if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
                                this.setState({leave: true, home: true})
                            }else{
                                this._home();
                            }}
                        } className={Styles.logoContainerIconMobile}
                             src={require("../../assets/images/logo_mobile.svg")}/>
                    </div>
                    <div className={Styles.menuContainer}>
                        {
                            this._renderView() &&
                            <div className={
                                cx(Styles.menuContainerInner,
                                    {
                                        [Styles.menuContainerPaddingUser]: tokenRegister.get(),
                                    })
                            }>
                                <div onClick={() => this._setView()} className={Styles.menuContainerInnerText}>
                                    {this._renderText("item_10")}
                                </div>
                                {
                                    this.state.quotesView === "custom" &&
                                    <img onClick={() => this._setView()} className={Styles.menuContainerInnerSlider} src={require("../../assets/images/push_black_off.svg")}/>
                                }
                                {
                                    !this.state.quotesView &&
                                    <img onClick={() => this._setView()} className={Styles.menuContainerInnerSlider} src={require("../../assets/images/slider_active.svg")}/>
                                }
                                <div onClick={() => this._setView()} className={Styles.menuContainerInnerText}>
                                    {this._renderText("item_11")}
                                </div>
                            </div>
                        }
                    </div>
                    {
                        this.state.view !== "select-market" &&
                        <div className={Styles.buttonContainer}>
                            <div className={Styles.languageButtonContainer}>
                                <div onClick={() => this.setState({dropdown: !this.state.dropdown})} className={Styles.languageButton}>
                                    {this.state.lang}
                                </div>
                                {
                                    this.state.dropdown &&
                                    <div>
                                        <div className={Styles.languageButtonDropdown}>
                                            {
                                                this.state.languages.map((item) => {
                                                    return(
                                                        <div onClick={() => this._setLang(item.code)} className={Styles.languageButtonDropdownItem}>
                                                            {item.names[langRegister.lang()]}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className={Styles.languageButtonTriangle}/>
                                    </div>
                                }
                            </div>
                            {
                                this.state.user.email && !this.state.user.inhouse && !this.state.user.reseller &&
                                <img onClick={() => {
                                    if(this.props.props.location.pathname.indexOf("signup/confirmation") === -1 && this.props.props.location.pathname.indexOf("signup") !== -1){
                                        this.setState({leave: true, profile: true})
                                    }else{
                                        this._profile();
                                    }}
                                } className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon.svg")}/>
                            }
                            {
                                this.state.user.email && (this.state.user.reseller || this.state.user.inhouse) &&
                                <img onClick={() => {
                                    if(this.props.props.location.pathname.indexOf("signup/confirmation") === -1 && this.props.props.location.pathname.indexOf("signup") !== -1){
                                        this.setState({leave: true, profile: true})
                                    }else{
                                        this._profile();
                                    }}
                                } className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon_reseller.svg")}/>
                            }
                            {
                                !this.state.user.email && this.state.view === "login" &&
                                <div onClick={() => this._register()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_1")}
                                </div>
                            }
                            {
                                !this.state.user.email && this.state.view !== "login" &&
                                <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_3")}
                                </div>
                            }
                            {
                                this.state.user.email &&
                                <div onClick={() => this._signout()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_2")}
                                </div>
                            }
                            <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                                 src={require("../../assets/images/menu_icon.svg")}/>
                        </div>

                    }
                    <HeaderMobileMenu props={this.props.props} ref={instance => {this.child = instance}} layout={true}/>
                </div>
            </div>
        );
    }
}

export default HeaderSignUpOne;


// WEBPACK FOOTER //
// ./src/components/header-signup-one/component.js